<template>
  <div>
    <customer-search-box
      :info-text="i18n.t('/KlantZoekenModal/NationaalZoekenInfo')"
      @on-search="search"
    />
    <loader v-if="loading" type="alert" />
    <alert v-if="errorText" :text="errorText" />
  </div>
</template>

<script>
import { required, email } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import CustomerSearchBox from '@/components/generic/presentational/molecules/customerSearch/CustomerSearchBox.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import CustomerSearchHelper from '@/helpers/CustomerSearchHelper'
import Customers from '@/api/server/Customers'

export default {
  components: {
    Alert,
    CustomerSearchBox,
    Loader,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  emits: ['hasSearchedNationalCustomers', 'hasSearchNationalCustomers'],
  setup() {
    return { v$: useVuelidate() }
  },
  validations: {
    userInput: {
      required,
      email,
    },
  },
  data() {
    return {
      userInput: '',
      loading: false,
      errorText: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  created() {
    StoreConnector.get('customer/customersSearchResults', () => {
      this.loading = false
    })
  },
  methods: {
    async search(query) {
      this.errorText = ''
      this.loading = true
      this.userInput = query

      this.$emit('hasSearchedNationalCustomers')
      let searchParams = this.getSearchNationalParams(query)
      if (!searchParams) {
        this.errorText = this.i18n.t('/KlantZoekenModal/NationaalZoekenError')
      } else {
        let foundCustomers = await Customers.searchNationalCustomers(searchParams)
        StoreConnector.dispatch('customer/searchCustomer', foundCustomers).then(() => {
          this.$emit('hasSearchNationalCustomers')
        })
      }
      this.loading = false
    },
    getSearchNationalParams(query) {
      let searchParams = null

      const poId = CustomerSearchHelper.filterPoId(query)
      const email = CustomerSearchHelper.filterEmail(query)
      const zipcodeAndHouseNumber = CustomerSearchHelper.filterZipcodeHouseNumber(query)
      const phoneNumber = CustomerSearchHelper.filterPhoneNumber(query)

      if (email) {
        searchParams = {
          email: email,
        }
      } else if (zipcodeAndHouseNumber && phoneNumber) {
        searchParams = {
          zipcode: zipcodeAndHouseNumber.zipcode,
          houseNumber: zipcodeAndHouseNumber.houseNumber,
          phoneNumber: phoneNumber,
        }
      } else if (phoneNumber) {
        searchParams = {
          phoneNumber: phoneNumber,
        }
      } else if (poId) {
        searchParams = {
          poId: poId,
        }
      }
      return searchParams
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  margin-bottom: 1em;
}

.search-wrapper {
  position: relative;
  margin-bottom: 0.5em;
}

input[type='search'] {
  width: 100%;
  flex: 1 1 auto;
  padding-right: 3em;
}

.btn-submit {
  $margin: 2px;

  border: 0;
  position: absolute;
  top: $margin;
  right: $margin;
  bottom: $margin;
  display: flex;
  align-items: center;
  background: $gray-lightest;
  padding: 0 0.75em;

  &:hover:not(:disabled) {
    background: $gray-light;
  }

  &[disabled] {
    color: $gray-light;
  }
}

label {
  display: block;
  margin-bottom: 0.5em;
}
</style>
